export function convertToCurrency(number) {
  const parsedNumber = parseFloat(number);

  if (isNaN(parsedNumber)) {
    return 0;
  }

  const value = Math.ceil(number);

  return value.toLocaleString('en-US');
}

export function convertToCurrencyWithSymbol(number) {
  const parsedNumber = parseFloat(number);

  if (isNaN(parsedNumber)) {
    return '$0';
  }

  const value = Math.ceil(parsedNumber);
  const formattedValue = Math.abs(value).toLocaleString('en-US');

  return value < 0 ? `-$${formattedValue}` : `$${formattedValue}`;
}

export function convertToCurrencyChart(number) {
  const value = Math.ceil(number);

  if (isNaN(value)) {
    return `$0`;
  }

  return `$${value.toLocaleString('en-US')}`;
}
